export default __webpack_public_path__ + "static/media/process_33.15841bd1.svg";